"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AliImager_1 = __importDefault(require("./ImageSrcHandlers/AliImager"));
var EZImager_1 = __importDefault(require("./ImageSrcHandlers/EZImager"));
var JDImager_1 = __importDefault(require("./ImageSrcHandlers/JDImager"));
var LitbImager_1 = __importDefault(require("./ImageSrcHandlers/LitbImager"));
var handlers = [AliImager_1.default, JDImager_1.default, LitbImager_1.default, EZImager_1.default];
function makeImageUrls(src, props) {
    var Hander = getHandler(src);
    if (!Hander) {
        console.error("ImageView 没有找到合适的处理类：" + src);
        return [src];
    }
    var handler = new Hander(src, props);
    return handler.makeImageUrls();
}
exports.makeImageUrls = makeImageUrls;
function getHandler(src) {
    var handler = handlers.find(function (h) {
        return h.match && h.match(src);
    });
    return handler || null;
}
